import React, { useEffect, useState } from 'react';
import { useDevice } from '../../contexts/DeviceContext';
import ExercisePopupsSection from '../ExercisePopupsSection';
import ExerciseStatsSection from '../ExerciseStatsSection';
import { exercisePopupsService } from '../../services/exercisePopupsService';
import { ExerciseTypeInfo } from '../../types/exercisePopups';

/**
 * Exercises tab: pop-up exercise settings for the selected device plus the child's
 * result statistics. The exercise-type catalog is loaded once here and shared so both
 * sections label types identically.
 */
const ExercisesPage: React.FC = () => {
  const { selectedDevice } = useDevice();
  const [exerciseTypes, setExerciseTypes] = useState<ExerciseTypeInfo[]>([]);
  const [typesLoading, setTypesLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setTypesLoading(true);
    exercisePopupsService
      .getExerciseTypes()
      .then((types) => {
        if (!cancelled) setExerciseTypes(types);
      })
      .catch((error) => {
        console.error('Failed to load exercise types:', error);
      })
      .finally(() => {
        if (!cancelled) setTypesLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!selectedDevice) return null;

  return (
    <>
      <ExercisePopupsSection exerciseTypes={exerciseTypes} typesLoading={typesLoading} />
      <ExerciseStatsSection exerciseTypes={exerciseTypes} />
    </>
  );
};

export default ExercisesPage;
